import { lighten } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { error, info, neutralDark, success, warning } from '../colors'
import { getPrimary } from '../utils'

export const createPalette = (config) => {
    const { colorPreset, contrast } = config

    return {
        // `neutralDark` is the `neutralLight` scale reversed: neutralDark[50]
        // is #111927 (near-black) and neutralDark[900] is #F8F9FA. The light
        // palettes tint these states with neutralLight[900] — ink over a pale
        // surface. The mirror of that on a dark surface is neutralDark[900],
        // not [100]: [100] is #1C2536, so every one of these states was being
        // painted near-black onto near-black. Disabled controls read as broken
        // rather than inactive, and hover/selected produced no visible feedback
        // at all.
        action: {
            active: neutralDark[500],
            disabled: alpha(neutralDark[900], 0.38),
            disabledBackground: alpha(neutralDark[900], 0.12),
            focus: alpha(neutralDark[900], 0.16),
            hover: alpha(neutralDark[900], 0.04),
            selected: alpha(neutralDark[900], 0.12)
        },
        background: {
            default: contrast === 'high' ? '#30363d' : '#30363d',
            paper:
                contrast === 'high'
                    ? lighten('#30363d', 0.1)
                    : lighten('#30363d', 0.02)
        },
        divider: '#496087',
        error,
        info,
        // MUI and this app only know 'light' and 'dark'; any other name gets light-mode styling.
        mode: 'dark',
        neutral: neutralDark,
        primary: getPrimary(colorPreset),
        success,
        text: {
            primary: '#EDF2F7',
            secondary: '#A0AEC0',
            disabled: 'rgba(255, 255, 255, 0.48)'
        },
        warning
    }
}
